import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer";

const Legal = () => {
  return (
    <>
      {/* <Header /> */}
      <div id="ajax-content-wrap">
        <div className="breadcrumb">
          <span>
            <span>
              <Link to="/">Home</Link> /{" "}
              <span className="breadcrumb_last" aria-current="page">
							Legal Disclaimer{" "}
              </span>
            </span>
          </span>{" "}
        </div>
        <div
          id="page-header-wrap"
          data-animate-in-effect="none"
          data-midnight="light"
          className=""
          style={{ height: "250px" }}
        >
          <div
            id="page-header-bg"
            className="not-loaded "
            data-padding-amt="low"
            data-animate-in-effect="none"
            data-midnight="light"
            data-text-effect="rotate_in"
            data-bg-pos="center"
            data-alignment="center"
            data-alignment-v="middle"
            data-parallax="0"
            data-height="250"
            style={{ backgroundColor: "#e8f5e5", height: "250px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col span_6 ">
                  <div className="inner-wrap">
                    <h1 className="top-heading">
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Legal
                        </span>
                      </span>{" "}
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Disclaimer
                        </span>
                      </span>
                    </h1>{" "}
                    <span
                      className="subheader"
                      style={{
                        transform: "rotateX(0deg) translate(0px)",
                        opacity: 1,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-wrap">
        <div className="container main-content">
    <div className="row">
        <div id="fws_661211e25cec9" data-column-margin="default" data-midnight="dark" className="wpb_row vc_row-fluid vc_row  vc_row-o-equal-height vc_row-flex   right_padding_85px left_padding_85px right_padding_tablet_65px right_padding_phone_20px left_padding_tablet_65px left_padding_phone_20px " style={{paddingTop: "60px", paddingBottom: "0px"}}>
            <div className="row-bg-wrap" data-bg-animation="none" data-bg-overlay="false">
                <div className="inner-wrap">
                    <div className="row-bg" style={{}}></div>
                </div>
            </div>
            <div className="row_col_wrap_12 col span_12 dark left">
                <div className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding inherit_tablet inherit_phone " data-padding-pos="all" data-has-bg-color="false" data-bg-color="" data-bg-opacity="1" data-animation="" data-delay="0">
                    <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                            <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                    <p style={{boxSizing: "border-box", margin: "0px 0px 1rem", fontFamily: "'Mallory Book', sans-serif",  color: "#212529"}}><span style={{boxSizing: "border-box", fontWeight: "bolder", color: "#000000"}}>1. NO WARRANTY</span></p>
                                    <p style={{boxSizing: "border-box", margin: "0px 0px 1rem", fontFamily: "'Mallory Book', sans-serif",  color: "#212529"}}><span style={{color: "#000000"}}>Please note that this is LapOtencielle, LLC’s disclaimer of legal liability for the quality or reliability of the products.</span></p>
                                    <p style={{boxSizing: "border-box", margin: "0px 0px 1rem", fontFamily: "'Mallory Book', sans-serif", color: "#212529"}}><span style={{color: "#000000"}}>LAPOTENCIELLE, LLC MAKES NO REPRESENTATION OR WARRANTY ABOUT THE PRODUCTS, INCLUDING ANY REPRESENTATION THAT THE PRODUCTS WILL BE UNINTERRUPTED OR ERROR-FREE AND PROVIDE THE PRODUCTS (INCLUDING CONTENT AND INFORMATION) ON “AS IS” AND “AS AVAILABLE” BASIS. TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW, WE DISCLAIM ANY IMPLIED OR STATUTORY WARRANTY, INCLUDING ANY IMPLIED OR STATUTORY WARRANTY, INCLUDING ANY IMPLIED WARRANTY OF TITLE, ACCURACY OF DATA, NON-INFRINGEMENT, MERCHANTIBILITY OR FITNESS FOR A PARTICULAR PURPOSE.</span></p>
                                </div>
                            </div>
                            <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                    <p><span style={{color: "#000000"}}><strong>2. EXCLUSION OF LIABILITY</strong></span></p>
                                    <p><span style={{color: "#000000"}}>Please note that these are the limits of legal liability LapOtencielle, LLC may have to you.</span></p>
                                    <p><span style={{color: "#000000"}}>TO THE FULLEST EXTENT PERMITTED BY LAW (AND UNLESS WE HAVE ENTERED INTO A SEPARATE WRITTEN AGREEMENT THAT OVERRIDES THIS AGREEMENT), LAPOTENCIELLE, LLC WILL NOT BE LIABLE IN CONNECTION WITH THIS AGREEMENT FOR LOST PROFITS OR LOST BUSINESS OPPORTUNITIES, REPUTATION (E.G., OFFENSIVE OR DEFAMATORY STATEMENTS), LOSS OF DATA (E.G., DOWN TIME OR LOSS OF YOUR INFORMATION OR CONTENT) OR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL OR PUNITIVE DAMAGES.</span></p>
                                    <p><span style={{color: "#000000"}}>LAPOTENCIELLE, LLC WILL NOT BE LIABLE TO YOU IN CONNECTION WITH THIS AGREEMENT.</span></p>
                                </div>
                            </div>
                            <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                    <p><span style={{color: "#000000"}}><strong>3. BASIS OF THE BARGAIN; EXCLUSIONS</strong></span></p>
                                    <p><span style={{color: "#000000"}}>The Limitations of Liability contained herein are part of the basis of the bargain between you and us and shall apply to all claims of liability (e.g., tort, contract, negligence and warranty) even if we have been told of the possibility of any such damage and even if these remedies fail their essential purpose.</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
        </div>

        <Footer />
        {/* Footer  */}
      </div>
    </>
  );
};

export default Legal;
